import React from 'react';
import BaseTabComponent from './../BaseTabComponent';
import {stringProps} from './../../mt-fields-to-save';

const currentIndex = 2;
const proformaIndex = 5;

export default class Expenses extends BaseTabComponent {
    constructor(props) {
        super(props);

        this.onTableValueChange = this.onTableValueChange.bind(this);
        this.addRows = this.addRows.bind(this);
        this.deleteRow = this.deleteRow.bind(this);
        this.handleExpand = this.handleExpand.bind(this);
    }

    handleExpand() {
        this.props.handleExpand({tabId: 'expenses-tab', tablesId: ['expenses'], cellsId: [4, 5, 6]});
        this.props.setState({isProformaVisible: !this.props.isProformaVisible});
    }

    onTableValueChange(tableIdentifier, rowCode, event, columnIndex) {
        const value = event.currentTarget.value;
        const tabs = [], tables = [], rowIds = [], values = [], columnIds = [];
        const updated = {};

        if (tableIdentifier === 'expenses' && rowCode.includes('cam-') && [currentIndex, proformaIndex].includes(columnIndex))
            updated.camChanged = true;
        if (tableIdentifier === 'expenses' && rowCode === 'management-fee' && [currentIndex, proformaIndex].includes(columnIndex))
            updated.mgmtChanged = true;
        if (tableIdentifier === 'expenses' && rowCode === 'insurance' && [currentIndex, proformaIndex].includes(columnIndex))
            updated.insuranceChanged = true;
        if (tableIdentifier === 'expenses' && rowCode === 'real-estate-taxes' && [currentIndex, proformaIndex].includes(columnIndex))
            updated.taxesChanged = true;

        if (columnIndex === currentIndex) {
            tabs.push('expenses-tab', 'expenses-tab');
            tables.push(tableIdentifier, tableIdentifier);
            rowIds.push(rowCode, rowCode);
            values.push(value, value);
            columnIds.push(columnIndex, proformaIndex);
        } else {
            tabs.push('expenses-tab');
            tables.push(tableIdentifier);
            rowIds.push(rowCode);
            values.push(value);
            columnIds.push(columnIndex);
        }

        this.props.valuesChange({
            tabs,
            tables,
            rowIds,
            values,
            columnIds,
            ...updated
        });
    }

    addRows(rowIdentifier) {
        this.props.addRow(['expenses-tab', 'current-reimbursement-tab'], [['expenses'], ['reimbursable-op-ex']], rowIdentifier, true);
    }

    deleteRow(rowIdentifier) {
        this.props.deleteRow(['expenses-tab', 'current-reimbursement-tab'], [['expenses'], ['reimbursable-op-ex']], rowIdentifier);
    }

    renderEditableValueCell(tableIdentifier, rowKey, row, columnIndex) {
        if (row.forceStatic) {
            return (
                <td className={`value-cell ${(row.styleClasses && row.styleClasses.length ? row.styleClasses : '')}`}
                    key={`${rowKey}-${columnIndex}`}>
                    <span className='text value'>
                        {row.value && row.unit === '$' ? row.unit : null}
                        {row.value && row.unit === '$' ? BaseTabComponent.addCommasToNumber(row.value) : row.value}
                        {row.value && row.unit !== '$' ? row.unit : null}
                        </span>
                </td>
            );
        }
        return (
            <td className='value-cell editable-cell' key={`${rowKey}-${columnIndex}`}>
                <label
                    className={`${row.type} ${(row.type === 'number' && (row.unit === '$' || row.unit === '%' || row.unit === 'SF' || row.unit === 'Acres' || row.unit === 'Years' || row.unit === 'bps' || row.name === 'Total Sq Ft')) ? 'formatted-number-label' : ''}`}>
                    <input value={row.value && parseFloat(row.value) !== 0 ? row.value : ''}
                           className={row.isWhite ? 'white' : ''}
                           onChange={(event) => this.onTableValueChange(tableIdentifier, rowKey, event, columnIndex)}
                           type={row.type !== 'date' ? row.type : null}
                           placeholder={row.type === 'date' ? 'MM/DD/YYYY' : row.unit}/>
                    <div
                        className={'input-display-value ' + (row.isWhite ? 'white' : '')}>
                        {row.value && parseFloat(row.value) !== 0 && row.unit === '$' ? row.unit : null}
                        {row.value && parseFloat(row.value) !== 0 ? BaseTabComponent.addCommasToNumber(row.value) : null}
                        {row.value && parseFloat(row.value) !== 0 && row.unit !== '$' ? (row.unit === 'Acres' || row.unit === 'SF' ? ` ${row.unit}` : row.unit) : null}
                        </div>
                </label>
                {
                    row.hasRowManipulation ?
                        <div className="more-button">
                            <div className="dot"/>
                            <div className="dot"/>
                            <div className="dot"/>
                            <div className="row-manipulation-container">
                                <div className="action-button" onClick={() => this.deleteRow(rowKey)}>Delete row</div>
                                <div className="action-button" onClick={() => this.addRows(rowKey)}>Add rows</div>
                            </div>
                        </div>
                    :
                        null
                }
            </td>
        );
    }

    render() {
        const tab = this.props.tabs['expenses-tab'];
        
        // Computing heavily-used values at the start of the render.
        const precomputedValues = BaseTabComponent.precomputeHeavilyUsedValues(this.props.tabs);

        return (
            <div className="Expenses">
                <div className="Financials_table_container">
                    <h3 className="Financials_table_title">{this.props.tabs['property-information-tab'].tables['general-information'].rows['property-name'].value}</h3>
                    {this.renderMatrixTable(tab.tables, 'general-information', precomputedValues)}

                    {this.renderMatrixTable(tab.tables, 'expenses', precomputedValues, true)}
                </div>
                <div className="Financials_table_container">
                    <h3 className="Financials_table_title">Expense Notes:</h3>
                    <textarea
                        onChange={(event) => {this.onTableValueChange('expense-notes', 'expense-notes', event, 0)}}
                        value={tab.tables['expense-notes'].rows['expense-notes'].valueCells[0].value}
                        disabled={stringProps[12] && stringProps[12].key === 'EXPENSES_NOTES' && !stringProps[12].hasOwnProperty('forceStatic')}
                    />
                </div>
            </div>
        )
    }
}